// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nc-0";
export var assigneeDetails = "_nc-1";
export var assigneeInfo = "_nc-2";
export var dropdownContainer = "_nc-4";
export var dropdownImage = "_nc-5";
export var editAssigneeInfo = "_nc-3";
export var editAssigneeModalContainer = "_nc-6";
export var hidden = "_nc-8";
export var input = "_nc-7";